import { type Room } from "matrix-js-sdk/src/matrix";

import { type TagID } from "../../../room-list-v3/skip-list/tag";
import { binarySearchInsertIndex, type IAlgorithm } from "./IAlgorithm";

/**
 * Sorts rooms according to the browser's determination of alphabetic.
 */
export class AlphabeticAlgorithm implements IAlgorithm {
    public sortRooms(rooms: Room[], tagId: TagID): Room[] {
        const collator = new Intl.Collator();
        return rooms.sort((a, b) => {
            return collator.compare(a.name, b.name);
        });
    }

    public getInsertIndex(sortedRooms: Room[], newRoom: Room, tagId: TagID): number {
        const collator = new Intl.Collator();
        return binarySearchInsertIndex(sortedRooms, newRoom, (a, b) => {
            return collator.compare(a.name, b.name);
        });
    }
}
